// Lib
import React, { ReactElement } from 'react';
import { Link } from '../../../../node_module_clones/react-router';
import { useDispatch, useSelector } from 'react-redux';

// Types
import { BreadcrumbResult } from '../../../workspace/breadcrumbs/breadcrumbUtil';
import Icon from '../../../components/icons/Icon';

// Selectors
import { getIsSheetOpen } from '../../structural/sheet/sheetSelectors';

// Actions
import { navigateToBoard } from '../../../reducers/navigationActions';
import { closeSheet } from '../../structural/sheet/sheetActions';

// Constants
import { SheetId } from '../../structural/sheet/sheetTypes';

// Styles
import './MobileBoardHeaderBackButton.scss';

interface MobileHeaderBackButtonProps {
    breadcrumbObj?: BreadcrumbResult;
}

const MobileBoardHeaderBackButton = (props: MobileHeaderBackButtonProps): ReactElement | null => {
    const { breadcrumbObj } = props;

    const dispatch = useDispatch();

    const isInboxSheetOpen = useSelector(getIsSheetOpen(SheetId.Inbox));

    if (!breadcrumbObj || !breadcrumbObj.complete) return null;

    const previousBoardId = breadcrumbObj.path?.[breadcrumbObj.path.length - 2];

    const handleBackClick = () => {
        dispatch(navigateToBoard({ boardId: previousBoardId }));
        if (isInboxSheetOpen) dispatch(closeSheet(SheetId.Inbox));
    };

    if (!previousBoardId) return null;

    return (
        <Link className="MobileBoardHeaderBackButton" onClick={handleBackClick}>
            <Icon name="mobile-header-back-chevron" />
        </Link>
    );
};

export default MobileBoardHeaderBackButton;
